interface IntegrationAccountFieldProps {
  label: string;
  value: string;
}

export default function IntegrationAccountField({
  label,
  value,
}: IntegrationAccountFieldProps) {
  return (
    <div className="flex flex-col items-start gap-y-1.5">
      <span className="text-button-xs">{label}</span>

      <h4 className="p-4 border-black-200 border w-full rounded-3xl text-md-bold">
        {value}
      </h4>

      <p className="text-xs text-black-500">
        To change your selected workspace, you must disconnect this one.
      </p>
    </div>
  );
}
